import { useEffect } from 'react';

import { ScriptList } from '@interfaces/homepage';

interface UseLoadScriptsProps {
  scriptList: ScriptList[];
}

const UseLoadScripts = ({ scriptList = [] }: UseLoadScriptsProps) => {
  useEffect(() => {
    if (scriptList.length === 0) return;

    const addedScripts: HTMLScriptElement[] = [];
    const scriptFragment = document.createDocumentFragment();

    scriptList.forEach((script) => {
      try {
        const scriptTag = document.createElement('script');
        script.attributes.forEach((attribute) => {
          scriptTag.setAttribute(attribute.name, attribute.value);
        });

        if (script.children) {
          const sanitizedScriptContent = script.children
            .replace(/[\u2018\u2019]/g, "'")
            .replace(/[\u201c\u201d]/g, '"');
          scriptTag.textContent = sanitizedScriptContent;
        }

        scriptFragment.appendChild(scriptTag);
        addedScripts.push(scriptTag);
      } catch (error) {
        console.error('Error loading script:', script, error);
      }
    });

    document.body.appendChild(scriptFragment);

    return () => {
      addedScripts.forEach((addedScript) => {
        addedScript.remove();
      });
    };
  }, [scriptList]);
};

export default UseLoadScripts;
